import { toast } from 'sonner';
import {
  isServer,
  QueryClient,
  MutationCache,
  defaultShouldDehydrateQuery,
} from '@tanstack/react-query';

import type { IErrorVM } from '~/types';

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
      dehydrate: {
        shouldDehydrateQuery: (query) => {
          return (
            defaultShouldDehydrateQuery(query) ||
            query.state.status === 'pending'
          );
        },
      },
    },
    mutationCache: new MutationCache({
      onError: (error, _variables, _context, mutation) => {
        if (!mutation.options?.meta?.manual) {
          const err = error as unknown as IErrorVM;
          const messages = Object.entries(err.errors || {});

          toast.error(err.title, {
            description: messages
              .map(([k, v]) => {
                return `${k}: ${v.join(', ')}`;
              })
              .join('\n'),
          });
        }
      },
    }),
  });
}

let browserQueryClient: QueryClient | undefined = undefined;

export function getQueryClient() {
  if (isServer) {
    return createQueryClient();
  } else {
    if (!browserQueryClient) {
      browserQueryClient = createQueryClient();
    }

    return browserQueryClient;
  }
}
